'use client';

import { CaptureUserDetailsProps } from '@/components/organisms/GatedContent/types';
import useCaptureUserDetails from '@/components/organisms/GatedContent/useCaptureUserDetails';
import { useTranslation } from '@/lib/i18n/i18n.client';
import DataCollectionForm from './DataCollectionForm';

type LeadCollectionFormProps = {
  captureUserDetailsProps: CaptureUserDetailsProps;
  onSubmitResult?: (status: 'success' | 'invalid' | 'error') => void;
};

export const LeadCollectionForm = ({
  captureUserDetailsProps: formProps,
  onSubmitResult,
}: LeadCollectionFormProps) => {
  const { texts } = useTranslation();
  const form = useCaptureUserDetails(formProps, { context: 'leadPopUp' });
  const { errors, handleSubmit, wasSubmitted, resetForm } = form;

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const result = await handleSubmit();
    if (result === true) {
      resetForm();
      onSubmitResult?.('success');
      return;
    }
    if (!onSubmitResult) return;
    if (errors.email) {
      onSubmitResult('invalid');
    } else {
      onSubmitResult('error');
    }
  };
  if (!formProps) return null;

  const shouldUseReducedEmailOnlyLayout =
    !formProps.isNameFieldVisible &&
    !formProps.isSurnameFieldVisible &&
    !formProps.isMessageFieldVisible;

  const mandatoryFieldsError =
    form.errors.firstName || form.errors.email
      ? texts.submission_status_message.please_fill_required_fields
      : '';
  const Content = (
    <DataCollectionForm
      // TODO: Ed - figure out why the form type doesnt want to set here
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      form={form}
      description={formProps.description}
      title={formProps.title}
      termsAndConditions={formProps.termsAndConditions}
      submitButtonText={formProps.submitButtonText}
      errors={{ ...errors, mandatoryFieldsError }}
      shouldUseReducedLayout={shouldUseReducedEmailOnlyLayout}
      handleSubmit={handleFormSubmit}
      fieldProps={{
        tnCProps: {
          variant: 'richText',
          shouldShow: true,
        },
        firstNameProps: {
          name: 'firstName',
          shouldShow: formProps.isNameFieldVisible,
          error:
            wasSubmitted && (!form.values.email || form.errors.email)
              ? texts.submission_status_message.invalid_email
              : form.errors.email || '',
        },
        companyNameProps: {
          name: 'companyName',
          shouldShow: false,
        },
        emailProps: {
          name: 'email',
          shouldShow: true,
          error:
            wasSubmitted && (!form.values.email || form.errors.email)
              ? texts.submission_status_message.invalid_email
              : form.errors.email || '',
        },
        lastNameProps: {
          name: 'lastName',
          shouldShow: formProps.isSurnameFieldVisible,
          error: shouldUseReducedEmailOnlyLayout
            ? form.errors.lastName || ''
            : '',
        },
        messageProps: {
          as: 'textarea',
          shouldShow: formProps.isMessageFieldVisible,
          name: 'message',
        },
        uploadFieldProps: {
          shouldShow: false,
        },
      }}
    />
  );

  return Content;
};
